<template>
  <CustomerFormBase v-model="localCustomer" :showBirthInfo="false" :showAddress="false" />
</template>

<script>
import CustomerFormBase from "@/components/pos/subscription/form/CustomerFormBase.vue";

export default {
  components: {
    CustomerFormBase,
  },
  props: {
    modelValue: Object,
  },
  computed: {
    localCustomer: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
